//Imports from common
import { roleTypeOptions } from "../../common/config/AppConstants";

export const filterRoleType = (value, filter) => {
  if (value !== null) {
    let roleType = "";

    roleTypeOptions.forEach(e => {
      if (value === e.value) {
        roleType = e.label;
      }
    });

    if (roleType.toLowerCase().indexOf(filter.toLowerCase()) !== -1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/components/Employees/FilterFunctions.js